/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Divider,
  Grid,
  Input,
  Paper,
  // CircularProgress,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { ThumbDownOutlined, ThumbUpOutlined } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import OpenWithIcon from '@material-ui/icons/OpenWith';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink } from 'react-router-dom';
import TableEditBar from 'src/components/TableEditBar';
import moment from 'moment';
import {
  generateUiString,
  secondsToHrsMinsSecs,
  selectMultipleRows,
  selectOneRow,
} from 'src/utils/general.utils';
import styled from 'styled-components';
import { TextToInputComponent } from './';
import { ChipsWithMore } from './chipsWithMore.component';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    '&:last-child': {
      padding: 0,
      paddingBottom: '0px',
    },
    padding: 0,
    paddingBottom: '0px',
  },
  inner: {
    minWidth: 700,
  },
  subCategoryTable: {
    minWidth: '0px',
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  tableHead: {
    backgroundColor: '#FAFAFA',
  },
  grey: {
    color: '#727272',
  },
  featuredonhomepage: {
    color: '#4CAF50',
    background: 'rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  featuredonleadpage: {
    color: '#2962FF',
    background: '#CAE3FF',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  open: {
    color: '#0053F5',
    background: '#D9F4FF',
    padding: theme.spacing(0.3, 2),
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  failed: {
    color: '#AF4C4C',
    background: '#FFDEDE',
    padding: theme.spacing(0.3, 2),
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  cancelled: {
    color: '#000000',
    background: '#D1D1D1', // need color
    padding: theme.spacing(0.3, 2),
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  submitted: {
    color: '#F57C00',
    background: '#FFECD9',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  running: {
    color: '#fff',
    background: '#0053F5',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  accelerated: {
    color: '#4CAF50',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
    border: '1px solid #4CAF50',
  },
  reserved: {
    color: '#3F51B5',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    border: '1px solid #3F51B5',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  featured: {
    color: '#2962FF',
    background: '#CAE3FF',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  listed: {
    color: '#4CAF50',
    border: '2px solid rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    width: '120px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  notlisted: {
    color: '#F57C00',
    border: '2px solid rgba(245, 124, 0, 0.2)',
    padding: '2px 16px 2px 16px',
    width: '120px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  complete: {
    color: '#4CAF50',
    background: 'rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  none: {
    color: '#4CAF50',
    background: 'rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  incomplete: {
    color: '#F57C00',
    background: 'rgba(245, 124, 0, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  extended: {
    color: '#4CAF50',
    background: 'rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  published: {
    color: '#4CAF50',
    background: 'rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  draft: {
    color: '#4CAF50',
    background: 'rgb(76, 175, 80, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  unpublished: {
    color: '#F57C00',
    background: 'rgba(245, 124, 0, 0.2)',
    padding: '2px 16px 2px 16px',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.272727px',
  },
  spinner: {
    display: 'block',
    width: '50px',
    height: '50px',
    margin: ' 50px auto',
  },
  colorRed: {
    color: '#b71c1c',
    fontSize: '18px',
    cursor: 'pointer',
  },
  colorSky: {
    color: '#00838f',
    fontSize: '18px',
    marginRight: '20px',
    cursor: 'pointer',
  },
  title: {
    fontWeight: '500',
  },
  search: {
    flexGrow: 1,
    height: 48,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon,
  },
  searchInput: {
    flexGrow: 1,
    border: 'none',
  },
  tableHeaderInputForm: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  emptyTable: {
    textAlign: 'center',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    lineHeight: '1.1875em',
    letterSpacing: '-0.05px',
  },
  textField: {
    borderBottom: 'none',
  },
  selectedRow: {
    backgroundColor: '#ecf3f3',
  },
  // eslint-disable-next-line no-dupe-keys
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
  },
  gridDiv: {
    display: 'flex',
    flexWrap: 'noWrap',
  },
  dInline: {
    display: 'flex',
    alignItems: 'center',
  },
  searchbox: {
    marginBottom: '20px',
  },
  hidden: {
    opacity: 0,
    marginBottom: '20px',
  },
  cursor: {
    cursor: 'pointer',
  },
  miTableCell: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: '20px',
    wordBreak: 'break-word',
  },
  tableCellAlignRight: {
    textAlign: 'right',
  },
  tableCellAlignCenter: {
    textAlign: 'center',
  },
  tableCellFlexEnd: {
    justifyContent: 'flex-end',
  },
  buttonAlign: {
    width: '1px',
    padding: '0px',
    paddingRight: '8px',
  },
  dragIcon: {
    marginLeft: theme.spacing(1),
  },
  extraWidth: {
    // width: "600px",
  },
  recordsData: {
    margin: '1.5rem 0 0.5rem',
  },
  infoIcon: {
    width: '20px',
    height: '20px',
    marginRight: '8px',
  },
  infoNameContainer: {
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    overflow: 'hidden',
    lineHeight: '24px',
    display: '-webkit-box',
    '-webkitLineClamp': '1',
    '-webkitBoxOrient': 'vertical',
  },
  videoAttach: {
    width: '120px',
    wordBreak: 'break-all',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    lineHeight: '28px',
    display: '-webkit-box',
    '-webkitLineClamp': '1',
    '-webkitBoxOrient': 'vertical',
  },
  closeAttachVideo: {
    cursor: 'pointer',
  },
  multiinfoContainer: {
    flexWrap: 'nowrap',
  },
  tootltip: {
    padding: '10px',
    fontSize: '14px',
    maxWidth: '360px',
  },
  tootltipVideo: {
    padding: '5px 10px',
    fontSize: '14px',
    maxWidth: '360px',
  },
}));

const CustomCardHeader = styled(CardHeader)`
  .MuiTypography-h5 {
    font-size: 14px;
    font-weight: bold;
  }
`;

function GridTable({
  searchText,
  tableConfig,
  subjects,
  onRowSelection,
  onRowDelete,
  onRowButtonClick = () => {},
  onSearchChange,
  onTableHeadInputClick,
  onTableTitleButtonClick,
  onTableRowClick,
  onTableIconClick,
  activeRowStatus,
  onTableDataChange,
  onPaginationChange = () => {},
  paginationExtraItem = 0,
  totalItems,
  page: controlledPage,
  rowsPerPage: controlledRowsPerPage,
}) {
  const classes = useStyles();
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedRowDetails, setSelectedRowDetails] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [inputRefState, setInputRefState] = useState(['', '']);
  const [rowCount, setRowCount] = useState(subjects.length);

  const [subjectsList, setSubjectsList] = useState(subjects);

  const [checkedRow, setCheckedRow] = useState({});

  const [tableUpdate, setTableUpdate] = useState(new Date());

  useEffect(() => {
    let inputRefArray = [];
    if (tableConfig && tableConfig.tableHeaderInputs) {
      tableConfig.tableHeaderInputs.elements.forEach(() => {
        inputRefArray.push('');
      });
    }
    setInputRefState(inputRefArray);
  }, [tableConfig, setInputRefState]);

  const { tableColumn, tableTitleButton, tableRow, pagination, checkBoxAsRadio } = tableConfig;

  const serverSidePagination = Boolean(pagination?.serverSide);
  const activePage = serverSidePagination ? controlledPage : page;
  const activeRowsPerPage = serverSidePagination ? controlledRowsPerPage : rowsPerPage;

  useEffect(() => {
    if (pagination?.defaultRowsPerPage) {
      setRowsPerPage(pagination?.defaultRowsPerPage);
    }
  }, [pagination]);

  useEffect(() => {
    setSubjectsList(subjects);
    setSelectedSubjects([]);
    setCheckedRow({});
    setTableUpdate(new Date());
  }, [subjects]);

  useEffect(() => {
    if (serverSidePagination) return;
    onPaginationChange({
      page,
      rowsPerPage,
      change: 'page',
    });
  }, [page]);

  useEffect(() => {
    if (serverSidePagination) return;
    onPaginationChange({
      page,
      rowsPerPage,
      change: 'rowsPerPage',
    });
  }, [rowsPerPage]);

  const updateActiveRowData = (rowData, mapDataToShow, status, index) => {
    if (typeof activeRowStatus === 'function') {
      activeRowStatus(rowData, mapDataToShow, status, index);
    }
  };

  const updateTableData = (tableData, result) => {
    if (typeof onTableDataChange === 'function') {
      onTableDataChange(tableData, result);
    }
  };

  const updateTableTitleButtonclick = event => {
    if (typeof onTableTitleButtonClick === 'function') {
      onTableTitleButtonClick(event);
    }
  };

  /*
    [Event Handlers]
    Handlers that will work with the events locally in the component.
    They will pass the changes to the emitters.
    For flexibility, they can also emit individual status.
  */

  const handleSelectAll = useCallback(
    (event, checkboxMap) => {
      let selectedRows = selectMultipleRows(event, subjectsList, checkboxMap);
      setSelectedSubjects(selectedRows);
      onRowSelection({ event, currentRow: selectedRows, selectedRows: [...selectedRows] });
    },
    [subjectsList, selectedSubjects]
  );

  const handleSelectOne = (event, subject, checkboxMap, index) => {
    let selectedRow;
    if (checkBoxAsRadio) {
      if (event.target.checked) {
        selectedRow = [subject];
      } else {
        selectedRow = [];
      }
    } else {
      selectedRow = selectOneRow(subject, selectedSubjects, checkboxMap);
    }
    setSelectedSubjects(selectedRow);
    onRowSelection({ event, currentRow: subject, selectedRows: [...selectedRow], index });
    setSelectedRowDetails(subject);
  };

  const handleInputValueChange = (inputData, rowData, mapDataToShow) => {
    if (inputData.valueChanged) {
      rowData[mapDataToShow] = inputData.currentValue;
      updateActiveRowData(rowData, mapDataToShow);
    }
  };

  const handleCellButtonClick = ({ subject, text, index }) => {
    updateActiveRowData(subject, text, '', index);
    onRowButtonClick(subject, index);
  };

  const handleSwitchToggle = ({ subject, mapDataToShow, status }) => {
    subject[mapDataToShow] = !subject[mapDataToShow];
    updateActiveRowData(subject, mapDataToShow, status);
  };

  const handleRowDelete = useCallback(() => {
    onRowDelete(selectedSubjects);
    setSelectedSubjects([]);
  }, [selectedSubjects]);

  const handleChangePage = (event, newPage) => {
    if (serverSidePagination) {
      onPaginationChange({ page: newPage, rowsPerPage: activeRowsPerPage, change: 'page' });
      return;
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    if (serverSidePagination) {
      onPaginationChange({ page: 0, rowsPerPage: event.target.value, change: 'rowsPerPage' });
      return;
    }
    setRowsPerPage(event.target.value);
  };

  const handleTableTitleclick = event => {
    updateTableTitleButtonclick(event);
  };

  /*
    [Utility Methods]
  */

  const isRowCheckedOrSelected = (subject, selectedSubject, checkboxMap) => {
    let selectedIndex;
    if (selectedSubjects.length) {
      for (let i = 0; i < selectedSubjects.length; i++) {
        if (selectedSubjects[i][checkboxMap] === subject[checkboxMap]) {
          selectedIndex = i;
          break;
        } else {
          selectedIndex = -1;
        }
      }
    } else {
      selectedIndex = -1;
    }

    return selectedIndex !== -1 ? true : false;
  };

  const handleInputBoxValidation = inputEntry => {
    if (inputEntry && inputEntry.trim()) {
      return false;
    } else {
      return true;
    }
  };

  const generateNavigationQuery = (queryList = [], rowData) => {
    let queryString = '?';
    let length = queryList.length;
    for (let i = 0; i < length; i++) {
      if (i > 0) {
        queryString = queryString + '&';
      }
      if (queryList[i].queryType === 'static') {
        queryString = queryString + queryList[i].queryName + '=' + queryList[i].queryValueMap;
      } else {
        queryString =
          queryString + queryList[i].queryName + '=' + rowData[queryList[i].queryValueMap];
      }
    }
    return queryString;
  };

  /*
    DRAG nd DROP methods
  */

  /*
    [JSX Creation methods]
  */

  const getTableCellElements = (tableItem, subject, index) => {
    const {
      element,
      mapDataToShow,
      disabled,
      title,
      elementConfig: {
        color,
        size,
        text,
        variant,
        to,
        apiKey,
        checkKey,
        component,
        startIcon,
        endIcon,
        queryList,
        transForm,
        plainText,
        multiLineClass,
        extraWidth,
        hideChildForZero,
        shouldHide,
        className,
      },
    } = tableItem;
    switch (element.toLowerCase()) {
      case 'chips':
        return (
          <React.Fragment>
            <Grid container justify="space-evenly" alignItems="center">
              {subject[mapDataToShow] &&
                subject[mapDataToShow].map(item => {
                  return (
                    <Grid key={item} item>
                      <Chip label={item} />
                    </Grid>
                  );
                })}
            </Grid>
          </React.Fragment>
        );

      case 'chipswithmore':
        return <ChipsWithMore items={subject[mapDataToShow]} />;

      case 'dragicon':
        return <OpenWithIcon fontSize="small" />;

      case 'span':
        return (
          <span
            className={
              subject[mapDataToShow]
                ? classes[subject[mapDataToShow].replace(' ', '').toLowerCase()]
                : 'incomplete'
            }
          >
            {subject[mapDataToShow] ? generateUiString(subject[mapDataToShow], '_', ' ') : null}
          </span>
        );
      case 'tag':
        return (
          <span
            className={
              subject[mapDataToShow] ? classes[text.replace(' ', '').toLowerCase()] : 'incomplete'
            }
          >
            {subject[mapDataToShow] && text ? text.toUpperCase() : null}
          </span>
        );
      case 'amount':
        return <span>Rs. {subject[mapDataToShow]}</span>;
      case 'na':
        return <span>{subject[mapDataToShow] ? subject[mapDataToShow] : 'NA'}</span>;
      case 'date':
        return (
          <span>
            {subject[mapDataToShow] ? moment(subject[mapDataToShow]).format('DD-MM-YYYY') : null}
          </span>
        );
      case 'statuslabel':
        return (
          <span
            className={
              subject[mapDataToShow]
                ? classes[mapDataToShow.replace(' ', '').toLowerCase()]
                : 'incomplete'
            }
          >
            {subject[mapDataToShow] ? generateUiString(subject[mapDataToShow], '_', '') : '-'}
          </span>
        );

      case 'button':
        if (shouldHide && shouldHide(subject)) return null;
        return (
          <Button
            color={color}
            component={component ? RouterLink : 'button'}
            size={size}
            to={to ? to + (queryList ? generateNavigationQuery(queryList, subject) : '') : null}
            variant={variant}
            startIcon={startIcon}
            endIcon={endIcon}
            disabled={typeof disabled === 'function' ? disabled(subject) : disabled}
            onClick={() => handleCellButtonClick({ subject, text, index })}
            className={className || ''}
          >
            {text}
          </Button>
        );

      case 'switch':
        return (
          <Switch
            checked={subject[mapDataToShow]}
            onChange={(event, status) =>
              handleSwitchToggle({ event, subject, mapDataToShow, status })
            }
            disabled={disabled || title === 'Trial Action' ? true : false}
            value={mapDataToShow}
            color="primary"
            inputProps={{
              'aria-label': 'Primary Checkbox',
            }}
          />
        );

      case 'icons':
        return (
          <React.Fragment>
            <ThumbUpOutlined
              className={classes.colorSky}
              onClick={event =>
                onTableIconClick
                  ? onTableIconClick({ event, subject, metaData: 'ThumbUpOutlined' })
                  : onTableIconClick
              }
            />
            <ThumbDownOutlined
              className={classes.colorRed}
              onClick={event =>
                onTableIconClick
                  ? onTableIconClick({ event, subject, metaData: 'ThumbDownOutlined' })
                  : onTableIconClick
              }
            />
          </React.Fragment>
        );

      case 'multiline':
        return (
          <React.Fragment>
            <div className={extraWidth ? classes.extraWidth : null}>
              <TextToInputComponent
                uiText={subject[tableItem.mapDataToShow]}
                disabled={disabled}
                onValueChange={inputData =>
                  handleInputValueChange(inputData, subject, mapDataToShow)
                }
              />

              {hideChildForZero ? (
                <div className={classes[multiLineClass]}>
                  {plainText
                    ? subject[tableItem.subDataKey]
                    : subject[tableItem.subDataKey] !== ''
                    ? secondsToHrsMinsSecs(subject[tableItem.subDataKey])
                    : subject[tableItem.subDataKey]}
                </div>
              ) : (
                <div className={classes[multiLineClass]}>
                  {plainText
                    ? subject[tableItem.subDataKey]
                    : secondsToHrsMinsSecs(subject[tableItem.subDataKey])}
                </div>
              )}
            </div>
          </React.Fragment>
        );

      case 'multilineinfo':
        return (
          <React.Fragment>
            <div className={extraWidth ? classes.extraWidth : null}>
              <Grid container className={classes.multiinfoContainer}>
                <Grid item>
                  <div>
                    <Tooltip
                      interactive
                      title={`
                            ${
                              subject[tableItem.subDataKey] !== '-'
                                ? `${tableItem.subDataName} : ${subject[tableItem.subDataKey]}`
                                : ''
                            }
                            ${
                              subject[tableItem.extraDataKey]
                                ? `${tableItem.extraDataName} : ${subject[tableItem.extraDataKey]}`
                                : ''
                            }
                          `}
                      classes={{
                        tooltip: classes.tootltip,
                      }}
                    >
                      <InfoIcon className={classes.infoIcon} />
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item>
                  <div className={classes.infoNameContainer}>
                    <Tooltip
                      interactive
                      title={subject[tableItem.mapDataToShow]}
                      className={classes.infoNameContainer}
                      classes={{
                        tooltip: classes.tootltip,
                      }}
                    >
                      <div>{subject[tableItem.mapDataToShow]}</div>
                    </Tooltip>
                  </div>
                </Grid>
              </Grid>
            </div>
          </React.Fragment>
        );

      case 'multiaction':
        if (transForm && subject[apiKey] && !subject[apiKey]?.pageContentId) {
          // show name with actions
          return (
            <React.Fragment>
              <Grid container spacing={1} className={classes.gridDiv}>
                <Grid item>
                  <InsertDriveFileOutlinedIcon />
                </Grid>
                <Grid item className={classes.videoAttach}>
                  <Tooltip
                    interactive
                    title={subject.videoDetails.videoName}
                    classes={{
                      tooltip: classes.tootltipVideo,
                    }}
                  >
                    <div>{subject.videoDetails.videoName}</div>
                  </Tooltip>
                </Grid>
                <Grid
                  item
                  onClick={() => {
                    if (!disabled) {
                      handleCellButtonClick({ subject, text });
                    }
                  }}
                  className={classes.closeAttachVideo}
                >
                  {!disabled && <CloseIcon />}
                </Grid>
              </Grid>
            </React.Fragment>
          );
        } else {
          // show button
          return (
            <React.Fragment>
              <Button
                color={color}
                component={component ? RouterLink : 'button'}
                size={size}
                to={to ? to + generateNavigationQuery(queryList, subject) : null}
                variant={variant}
                startIcon={startIcon}
                disabled={
                  (typeof disabled === 'function' ? disabled(subject) : disabled) ||
                  subject[checkKey]
                }
                onClick={() => handleCellButtonClick({ subject, text })}
              >
                {text}
              </Button>
            </React.Fragment>
          );
        }

      default:
        return null;
    }
  };

  const buildCheckboxCell = (tableItem, index, subject = '', head = true, rowIndex) => {
    const {
      checkboxMap,
      useDragAndDrop,
      showDragAndDropIcon,
      checkBoxAsRadio,
      hideHeadCheckbox,
    } = tableConfig;
    const { disabled, hideCheckbox } = tableItem;

    return (
      <TableCell padding={tableItem.padding ? tableItem.padding : ''} key={index}>
        <div className={classes.dInline}>
          {!hideCheckbox && (!hideHeadCheckbox || !head) && (
            <Checkbox
              checked={
                checkBoxAsRadio && !head
                  ? subject[checkboxMap] === checkedRow[checkboxMap]
                  : head
                  ? subjectsList &&
                    subjectsList.length &&
                    selectedSubjects.length === subjectsList.length
                  : isRowCheckedOrSelected(subject, selectedSubjects, checkboxMap)
              }
              color={tableItem.color}
              indeterminate={
                head && selectedSubjects.length > 0 && selectedSubjects.length < subjectsList.length
              }
              onChange={event => {
                if (checkedRow[checkboxMap] === subject[checkboxMap]) {
                  setCheckedRow({});
                } else {
                  setCheckedRow(subject);
                }
                return head
                  ? tableItem.onAllChange === 'handleSelectAll'
                    ? handleSelectAll(event, checkboxMap)
                    : null
                  : tableItem.onOneChange === 'handleSelectOne'
                  ? handleSelectOne(event, subject, checkboxMap, rowIndex)
                  : null;
              }}
              disabled={disabled}
            />
          )}
          {!head && showDragAndDropIcon && !hideCheckbox && (
            <OpenWithIcon fontSize="small" color={useDragAndDrop ? '' : 'disabled'} />
          )}
          {hideCheckbox && (
            <Grid className={classes['dragIcon']}>
              <OpenWithIcon fontSize="small" color={useDragAndDrop ? '' : 'disabled'} />
            </Grid>
          )}
        </div>
      </TableCell>
    );
  };

  const buildTableCell = (tableItem, index, subject = '', head = false, rowIndex) => {
    return (
      <TableCell
        style={{ maxWidth: tableItem.extraWidth ? tableItem.extraWidth : '200px' }}
        align={tableItem.align ? tableItem.align : 'inherit'}
        key={index}
        classes={{
          body: tableItem.tdClass ? classes[tableItem.tdClass] : '',
        }}
      >
        <div
          className={`
            ${tableItem.class ? classes[tableItem.class] : classes.miTableCell}
            ${tableItem.extraWidth ? classes.extraWidth : null}
          `}
        >
          {!head
            ? tableItem.child
              ? getTableCellElements(tableItem, subject, rowIndex)
              : tableItem.renderTableItem
              ? tableItem.renderTableItem(subject)
              : subject[tableItem.mapDataToShow]
            : tableItem.renderTitle
            ? tableItem.renderTitle()
            : tableItem.title}
        </div>
      </TableCell>
    );
  };

  const generateTableColumns = useCallback(
    (index = 0, subject = '', head = true) => {
      const { checkboxMap, useDragAndDrop, tableRowPointer } = tableConfig;

      // Generate column elements for each row
      let tableHeadCells = tableColumn.config.map((tableItem, i) => {
        if (tableItem.input) {
          if (tableItem.inputType === 'checkbox') {
            return buildCheckboxCell(tableItem, i, subject, head, index);
          }
        } else {
          return buildTableCell(tableItem, i, subject, head, index);
        }
        return 0;
      });

      // Create a table row with all the cells
      return (
        <React.Fragment>
          {!head && useDragAndDrop ? (
            <Draggable draggableId={`${index}`} index={index}>
              {provided => (
                <TableRow
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  className={`${subject.selected ? classes.selectedRow : ''} ${
                    tableRowPointer ? classes['cursor'] : null
                  }`}
                  key={index}
                  hover={!head && tableRow.hover}
                  selected={
                    // Add background color to indicate row selection
                    !head && isRowCheckedOrSelected(subject, selectedSubjects, checkboxMap)
                  }
                  onClick={event =>
                    !head && onTableRowClick
                      ? onTableRowClick(event, subject, selectedSubjects)
                      : onTableRowClick
                  }
                >
                  {tableHeadCells}
                </TableRow>
              )}
            </Draggable>
          ) : (
            <TableRow
              className={`${subject.selected ? classes.selectedRow : ''} ${
                tableRowPointer ? classes['cursor'] : null
              }`}
              key={index}
              hover={!head && tableRow.hover}
              selected={
                // Add background color to indicate row selection
                !head && isRowCheckedOrSelected(subject, selectedSubjects, checkboxMap)
              }
              onClick={event =>
                !head && onTableRowClick ? onTableRowClick(event, subject) : onTableRowClick
              }
            >
              {tableHeadCells}
            </TableRow>
          )}
        </React.Fragment>
      );
    },
    [tableColumn, tableRow, selectedSubjects, subjectsList]
  );

  const generateTableRows = useCallback(
    provided => {
      const {
        searchTextMap,
        emptyTableMessage,
        emptySearchMessage,
        tableColumn: { config },
      } = tableConfig;
      let subjectsCopy = subjectsList;

      if (searchTextMap) {
        searchText = searchText.trim();
        if (searchText) {
          subjectsCopy = subjectsCopy.filter(subject => {
            return subject[searchTextMap]?.toLowerCase()?.includes(searchText?.toLowerCase());
          });
        }
        subjectsCopy = subjectsCopy ? subjectsCopy : [];
        setRowCount(subjectsCopy.length);
      }

      // generate all rows initially
      let tableBodyCells = subjectsCopy.map((subject, index) => {
        return generateTableColumns(index, subject, false);
      });

      if (!subjectsCopy.length) {
        return (
          <TableRow ref={provided.innerRef} {...provided.droppableProps}>
            <TableCell colSpan={config.length} className={classes.emptyTable}>
              {searchText ? emptySearchMessage : emptyTableMessage}
            </TableCell>
          </TableRow>
        );
      }

      // pagination.
      if (pagination && pagination.usePagination && !serverSidePagination) {
        let startIndex = page * rowsPerPage;
        let endIndex = startIndex + rowsPerPage;
        endIndex = endIndex > tableBodyCells.length ? tableBodyCells.length : endIndex;
        let paginatedRows = tableBodyCells.slice(startIndex, endIndex);
        if (startIndex > tableBodyCells.length) {
          setPage(0);
          return;
        }
        return paginatedRows;
      }

      return tableBodyCells;
    },
    [subjectsList, page, rowsPerPage, searchText, pagination, selectedSubjects, tableConfig]
  );

  const getSearchBox = (element, index) => {
    const { id, placeholder, type } = element;
    return (
      <React.Fragment>
        <SearchIcon className={classes.searchIcon} />
        <Input
          id={id}
          autoComplete="off"
          className={classes.searchInput}
          disableUnderline
          placeholder={placeholder}
          type={type}
          onChange={event =>
            onSearchChange
              ? onSearchChange(event, event.target.value, index, element)
              : onSearchChange
          }
        />
      </React.Fragment>
    );
  };

  const getInputBox = (element, index) => {
    const { id, placeholder, buttonText, tableMap, disabled } = element;

    const handleFormSubmit = event => {
      event.preventDefault();
      setInputRefState(['', '']);
      onTableHeadInputClick(event, inputRefState[index], tableMap);
    };

    return (
      <React.Fragment>
        <form onSubmit={handleFormSubmit} className={classes.tableHeaderInputForm}>
          <Input
            autoComplete="off"
            id={id}
            className={classes.searchInput}
            disableUnderline
            placeholder={placeholder}
            disabled={disabled}
            inputProps={{
              maxLength: 200,
            }}
            value={inputRefState[index]}
            onChange={event => {
              let value = event.target.value;
              let dataIndex = index;
              setInputRefState(state => {
                return state.map((item, index) => {
                  if (index === dataIndex) {
                    return (item = value);
                  } else {
                    return item;
                  }
                });
              });
            }}
          />
          <Button
            className={classes.searchButton}
            size="small"
            variant="contained"
            color="primary"
            disabled={disabled || handleInputBoxValidation(inputRefState[index])}
            onClick={event => {
              setInputRefState(['', '']);
              return onTableHeadInputClick
                ? onTableHeadInputClick(event, inputRefState[index], tableMap)
                : onTableHeadInputClick;
            }}
          >
            {buttonText}
          </Button>
        </form>
      </React.Fragment>
    );
  };

  const getTableHeaderInputs = (element, index) => {
    const { elementType } = element;
    switch (elementType.toLowerCase()) {
      case 'searchbox':
        return getSearchBox(element, index);
      case 'inputbox':
        return getInputBox(element, index);
      default:
        return null;
    }
  };

  // add a card for empty table

  const createTable = () => {
    return (
      <React.Fragment>
        {tableConfig.tableHeaderInputs ? (
          <div className={classes.root}>
            {tableConfig.tableHeaderInputs.elements.map((element, index) => (
              <Paper
                className={`${classes.search} ${classes[element.elementType.toLowerCase()]}`}
                elevation={1}
                key={index}
              >
                {getTableHeaderInputs(element, index)}
              </Paper>
            ))}
          </div>
        ) : !tableConfig.hideRecordsData ? (
          <Typography color="textSecondary" className={classes.recordsData} variant="body2">
            {subjectsList.length} Records found. Page {page + 1} of{' '}
            {Math.ceil(subjectsList.length / rowsPerPage)}
          </Typography>
        ) : null}
        <Card>
          <Grid container justify="space-between" alignContent="center">
            {tableConfig.tableTitle && <CustomCardHeader title={tableConfig.tableTitle} />}
            {tableTitleButton && tableTitleButton.showButton && (
              <CardActions>
                <Button onClick={handleTableTitleclick} color="primary" variant="outlined">
                  {tableTitleButton.buttonText}
                </Button>
              </CardActions>
            )}
          </Grid>

          <Divider />
          <CardContent
            className={classes.content}
            classes={{
              root: classes.content,
            }}
          >
            <PerfectScrollbar>
              <div
                className={` ${
                  tableConfig.tableMinWidthClass
                    ? classes[tableConfig.tableMinWidthClass]
                    : classes.inner
                }`}
              >
                <Table>
                  {!tableConfig.hideTableTitle && <TableHead>{generateTableColumns()}</TableHead>}
                  <Droppable droppableId="list" key={tableUpdate}>
                    {provided => (
                      <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                        {generateTableRows(provided)}
                      </TableBody>
                    )}
                  </Droppable>
                </Table>
              </div>
            </PerfectScrollbar>
          </CardContent>

          {pagination && pagination.usePagination ? (
            <CardActions className={classes.actions}>
              <TablePagination
                component="div"
                count={totalItems || rowCount + paginationExtraItem}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={activePage}
                rowsPerPage={activeRowsPerPage}
                rowsPerPageOptions={pagination.rowsPerPageOptions}
                row
              />
            </CardActions>
          ) : null}
        </Card>
        {tableConfig.useEditBar ? (
          <TableEditBar
            selected={selectedSubjects}
            content={tableConfig.editBarText}
            onDelete={handleRowDelete}
            actionClass="negativeAction"
            showIcon={true}
          />
        ) : null}
      </React.Fragment>
    );
  };

  function onItemDragEnd(result) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    if (result.source.index !== result.destination.index && tableConfig.useDragAndDrop) {
      let items = _.cloneDeep(subjects);
      let selectedRow = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, ...selectedRow);
      setSubjectsList(items);
      updateTableData(items, result);
    }
  }

  return (
    <React.Fragment>
      <DragDropContext onDragEnd={onItemDragEnd}>{createTable()}</DragDropContext>
    </React.Fragment>
  );
}

export { GridTable };
